<template>
  <div class="prose">
    <div v-for="(table, i) in rule.tables" :key="i" class="mb-7">
      <table
        class="w-full bg-[#fffdfa] rounded-b-2xl shadow-[0_2px_6px_rgba(0,0,0,0.06)] border-collapse"
      >
        <caption
          class="font-semibold py-3 px-3 bg-[#d1a66a] text-white rounded-t-2xl border-b border-[#e5ded2]"
        >
          {{
            table.caption
          }}
        </caption>
        <thead>
          <tr>
            <th
              v-for="(col, j) in table.columns"
              :key="j"
              class="px-3 py-3 font-semibold bg-[#f9f6f1] border-b border-[#e5ded2] text-left"
            >
              {{ col }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, rIndex) in table.rows" :key="rIndex">
            <td
              v-for="(cell, cIndex) in row"
              :key="cIndex"
              :class="[
                'px-3 py-3 border-b border-[#e5ded2] text-left',
                rIndex === table.rows.length - 1 ? 'border-b-0' : ''
              ]"
              v-html="cell"
            ></td>
          </tr>
        </tbody>
      </table>
    </div>

    <p v-html="rule.description"></p>

    <div v-if="rule.examples && rule.examples.length">
      <span class="font-semibold">Examples:</span>
      <ul>
        <li
          v-for="(example, i) in rule.examples"
          :key="i"
          v-html="example"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GrammarRule',

  props: {
    rule: { type: Object, required: true }
  }
}
</script>

<style scoped>
/* Code styling for prose content */
:deep(code) {
  background: #f3ede4;
  padding: 3px 8px;
  border-radius: 6px;
}

:deep(code::after),
:deep(code::before) {
  content: '' !important;
}
</style>
